import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { slugify } from '../helpers';

class Square extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { value, sectorName } = this.props.square;

    const slug = sectorName;

    const san = slugify(slug);

    const parent = this.props.sectors[0].parentName;

    const parSlug = slugify(parent);

    const url = `/industries/${parSlug}/${san}/`;

    return (
      <dd
        className={`grid__item ${
          value < 1
            ? 'app--na'
            : value < 2
              ? 'app--limited'
              : value < 4
                ? 'app--qualified'
                : 'app--strong'
        }`}
      >
        <Link className="grid__link" to={{ pathname: url }} data-cta={`Appetite: ${sectorName}`}>
          <span className="grid__text">{sectorName}</span>
        </Link>
      </dd>
    );
  }
}

export default Square;



// WEBPACK FOOTER //
// ./src/components/Square.js